import axios from '@/plugins/axiosInstance'
import { googleIntegration } from '@/networking/urlManager'

/**
 * Fetches Google accounts associated with the user
 * @returns {Promise<Array>} List of Google accounts
 */
export const getAccounts = async () => {
  try {
    const response = await axios.get(googleIntegration.accounts)
    return response.data.data || []
  } catch (error) {
    throw error
  }
}
